export default function Gallery() {
  return (
    <div className="bg-white py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20 font-montserrat">
      <div className="max-w-6xl mx-auto relative border border-gray-200 bg-white overflow-hidden shadow-lg">
        {/* Background Abstract Design */}
        <div className="absolute -right-[20%] -top-[20%] pointer-events-none opacity-10">
          <div className="w-[2406px] h-[1608px] bg-gradient-to-br from-primary/20 to-transparent"></div>
        </div>

        {/* Content Container */}
        <div className="relative p-8 md:p-12 lg:p-20 flex flex-col gap-8 md:gap-12 lg:gap-20">
          {/* Image Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Left Column */}
            <div className="flex flex-col gap-5">
              <div className="relative aspect-[3/1] overflow-hidden bg-gray-100">
                <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                  <span className="text-gray-500 text-lg font-medium">Office Workspace</span>
                </div>
              </div>
              <div className="relative aspect-[3/1] overflow-hidden bg-gray-100">
                <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                  <span className="text-gray-500 text-lg font-medium">Team Collaboration</span>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="flex flex-col gap-5">
              <div className="relative aspect-[3/1] overflow-hidden bg-gray-100">
                <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                  <span className="text-gray-500 text-lg font-medium">Professional Team</span>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-5">
                <div className="relative aspect-[3/2] overflow-hidden bg-gray-100">
                  <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                    <span className="text-gray-500 text-sm font-medium text-center">Business Professionals</span>
                  </div>
                </div>
                <div className="relative aspect-[3/2] overflow-hidden bg-gray-100">
                  <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                    <span className="text-gray-500 text-sm font-medium text-center">Team Meeting</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Text Section */}
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-8 lg:gap-5 items-center">
            {/* Text Content */}
            <div className="flex flex-col gap-3.5 pr-0 lg:pr-5 relative">
     
              <h1 className="text-primary font-montserrat text-2xl md:text-3xl lg:text-4xl font-semibold leading-[150%]">
                Explore Alkina Realty's World
              </h1>
              <p className="text-slate-600 font-montserrat text-sm md:text-base font-medium leading-[150%]">
                Step inside the world of Alkina Realty, where professionalism meets
                warmth, and expertise meets passion. Our gallery offers a
                glimpse into our team and workspaces, inviting you to get to
                know us better.
              </p>
            </div>

            {/* Right Side Image */}
            <div className="relative h-[200px] lg:w-[400px] xl:w-[500px] overflow-hidden bg-gray-100">
              <div className="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
                <span className="text-gray-500 text-lg font-medium">Business Handshake</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

